/**
 * Per-module personalisation (governance ADR-033; UI contract rule 14). What one module does that
 * others do not is DATA in web/module-slots.json (kit default) and web/instances/<name>/module-slots.json
 * (the _project's choices for one customer); this file only registers the named panels those files
 * may place. Everything generic (lifecycle, deadlines, Markdown, obligations, related column) comes
 * from descriptor hints in the generated pages.
 */
import { setModuleSlots, type ModuleSlotsFile, type SlotPanelComponent } from "@evo-flywheel/ui";
import { AcceptancePanel } from "./acceptance";
import { AmlRegister } from "./aml";
import { AuditSnapshots } from "./audit";
import { ProcessingRegister } from "./register";
import { MeasuresCoverage, RiskHeatmap, RiskMeasures } from "./risk";
import { kernel } from "../api";
import { instance } from "../instance";
import kitSlots from "../../module-slots.json";

/** Panels a module-slots file may name. Adding one here is the only code a new slot needs. */
export const PANELS = {
  AcceptancePanel, AmlRegister, AuditSnapshots, ProcessingRegister, MeasuresCoverage, RiskHeatmap, RiskMeasures,
} as unknown as Record<string, SlotPanelComponent>;

const instanceSlots = import.meta.glob("../../instances/*/module-slots.json", { eager: true, import: "default" }) as Record<string, ModuleSlotsFile>;

setModuleSlots({
  layers: [kitSlots as ModuleSlotsFile, instanceSlots[`../../instances/${instance.name}/module-slots.json`]],
  panels: PANELS,
  fetchKernel: (path) => kernel(path),
});
